/**
 * TASKS.SELF
 * Find my own action plan
 */
import PageHeader from "@/components/page-header"
import NavApp from "@/nav/nav.app"
import { WithTranslation, withTranslation } from "react-i18next"
import { useState } from "react"
import { connect } from "react-redux"
import { Session } from "@/redux/_session.types"
import Button from "@/components/button"
import TasksAddModal from "@/modals/tasks-add.modal"
import TasksActionPlansWidget from "@/widgets/tasks-action-plans.widget"

interface StateProps extends WithTranslation {
  _session: Session
}

const MODAL_ADD = "MODAL_ADD"

function TasksSelfRoute(props: StateProps) {
  const { t } = props
  const [currentModal, setCurrentModal] = useState<string | null>(null)
  return (
    <NavApp>
      {currentModal === MODAL_ADD && <TasksAddModal onClose={() => setCurrentModal(null)} />}
      <PageHeader title={t("tasks_self")} subtitle={t("tasks_self_help")}>
        <Button isFullWidth className="primary" onClick={() => setCurrentModal(MODAL_ADD)}>
          {t("tasks_add")}
        </Button>
      </PageHeader>
      <TasksActionPlansWidget isSelf />
    </NavApp>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session
})

export default connect(mapStateToProps)(withTranslation()(TasksSelfRoute))
